define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "../../models/UserContext", "../../models/ServerModel", "./serverActions"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, UserContext, ServerModel, ServerActions) {
    "use strict";
    var ServerDetails = /** @class */ (function () {
        function ServerDetails() {
            this.serverId = ko.observable(0);
            this.editModel = ko.observable(new ServerModel());
            this.actions = new ServerActions();
            this.canUserSeePassword = ko.observable(UserContext.hasAccess("Servers.AllowSeePassword") || UserContext.hasAccess("Admin"));
            this.badRequest = false;
        }
        ServerDetails.prototype.init = function (id) {
            var self = this;
            self.serverId(id);
            $("#page-title").text("Server Details");
            self.badRequest = false;
            var getModelCall = tools.ajaxGet({
                url: "/Servers/GetById",
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new ServerModel(result.Data));
                        if (UserContext.hasAccess("Admin") || UserContext.hasAccess("Servers.Edit") || UserContext.hasAccess("Servers.Delete")) {
                            $("#ko-main-content").on("click", ".btn-edit", function (event) {
                                self.actions.editServer(self.editModel().Id(), self.editModel().IpAddress());
                                event.preventDefault();
                            });
                        }
                        self.actions.saveCallback = function (data) {
                            self.editModel(new ServerModel(data));
                            if (self.dataLogs) {
                                self.dataLogs.refreshLogs();
                            }
                        };
                        self.actions.passwordCallback = function (data) {
                            self.editModel().PasswordPreview(data);
                        };
                    }
                    else {
                        self.badRequest = true;
                        log.error(result.Error);
                    }
                }
            });
            $.when(getModelCall).done(function () {
                $("#contextLoader").hide();
                $("#mainContext").show();
                ko.applyBindings(self, document.getElementById("main-container"));
            });
        };
        ServerDetails.prototype.hidePassword = function () {
            var self = this;
            self.editModel().PasswordPreview("******");
        };
        ServerDetails.prototype.viewPassword = function () {
            var self = this;
            self.actions.viewServerPasswordConfirm(self.editModel().Id(), self.editModel().IpAddress());
        };
        ServerDetails.prototype.addServer = function () {
            var self = this;
            self.actions.editServer();
        };
        ServerDetails.prototype.showLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Server", self.serverId());
                dataLogs.open("Server logs");
            }
        };
        return ServerDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Servers/Details")) {
            var id = urls_1.urls.getIdFromQueryString();
            if (id <= 0) {
                id = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize Server Details id: " + id);
            $(function () {
                (new ServerDetails()).init(id);
            });
        }
    }, 0);
    return ServerDetails;
});
//# sourceMappingURL=serverDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/servers/serverDetails.js
// module id = 246
// module chunks = 2